import {
  Box,
  FilePickerErrorType,
  FilePickerWithPreview,
  Text,
} from "src/components";
import { CheckboxContainerEl, GridContainerEl } from "./BusinessInfo.styled";
import { eventDispatcher } from "src/helpers/eventEmitter";
import React, { useState } from "react";
import { useBusinessInfoState } from "./BusinessInfo.state";
import { errFormatter } from "src/helpers";
import { usePassportStore } from "src/stores";
import Checkbox from "@asphalt-react/checkbox";
import { observer } from "mobx-react-lite";
import { useTranslation } from "src/hooks";
import { GuideModal } from "./PhysicalBusiness.guide";

const {
  NetworkError,
  FileInvalidType,
  FileMaxSize,
  FileMaxCount,
} = FilePickerErrorType;

export const PhysicalBusinessForm: React.FC = observer(() => {
  const translate = useTranslation();
  const store = usePassportStore();
  const state = useBusinessInfoState();
  const { form } = state;
  const [showInfoModal, setShowInfoModal] = useState(false);

  const handlePhysicalBusinessUpload = async (file: File) => {
    try {
      state.inputErrors.physical_business_upload.isError = false;
      await state.uploadFilePhysicalBusiness(store?.authUser?.id!, file);
      eventDispatcher.publish({
        action: "ob_upload_physical_business_success",
      });
      state.setPhysicalBusinessFile(file);
    } catch (e) {
      state.inputErrors.physical_business_upload.isError = true;
      const { status, message } = errFormatter(e);
      eventDispatcher.publish({
        action: "ob_upload_physical_business_error",
        payload: {
          fileType: file.type,
          message: message,
          httpStatus: status,
        },
      });
    }
  };

  return (
    <>
      <CheckboxContainerEl flex alignItemsCenter marginTopXxl>
        <Checkbox
          checked={state.hasPhysicalBusiness}
          onChange={() =>
            (state.hasPhysicalBusiness = !state.hasPhysicalBusiness)
          }
          id="checkbox-physical-business"
        />
        <Text
          fontSize="medium"
          marginLeftS
          fontWeight="demi"
          as="label"
          htmlFor="checkbox-physical-business"
        >
          {translate("business_info.checkbox.physical_business")}
        </Text>
      </CheckboxContainerEl>

      {state.hasPhysicalBusiness && (
        <Box marginBottomL>
          <GridContainerEl>
            <GuideModal
              show={showInfoModal}
              onClose={() => setShowInfoModal(false)}
            />
            <FilePickerWithPreview
              onClick={() =>
                eventDispatcher.publish({
                  action: "ob_upload_physical_business",
                })
              }
              maxSize={5}
              onChange={(file) => handlePhysicalBusinessUpload(file)}
              isLoading={state?.loadingState.has.uploadFilePhysicalBusiness}
              previewUrl={form.business_photo?.url}
              tempFile={form.business_photo?.temp}
              onDelete={() => state.deletePhysicalBusinessFile()}
              onError={(error) => {
                eventDispatcher.publish({
                  action: "ob_upload_physical_business_error",
                  payload: { message: error.message },
                });
              }}
              isError={state.inputErrors.physical_business_upload.isError}
              buttonText={translate(
                "business_info.cta.upload_physical_business"
              )}
              getErrorTranslation={(error) => {
                switch (error) {
                  case NetworkError:
                    return translate(
                      "business_info.errors.physical_business.general"
                    );
                  case FileInvalidType:
                    return translate(
                      "business_info.errors.physical_business.image_invalid_type"
                    );
                  case FileMaxCount:
                    return translate(
                      "business_info.errors.physical_business.too_many_files"
                    );
                  case FileMaxSize:
                    return translate(
                      "business_info.errors.physical_business.image_too_large"
                    );
                  default:
                    return translate(
                      "business_info.errors.physical_business.general"
                    );
                }
              }}
              onInfoClick={() => setShowInfoModal(true)}
              helperText={translate("business_info.helper.physical_business")}
              acceptedTypes={["image/jpg", "image/jpeg", "image/png"]}
            />
          </GridContainerEl>
        </Box>
      )}
    </>
  );
});
